"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitialDataLayer = exports.createDataLayerLibraryInnerHtml = void 0;
const build_xhr_request_1 = require("./lib/build.xhr.request");
const create_app_data_1 = __importDefault(require("./lib/create.app.data"));
const create_econda_data_1 = __importDefault(require("./lib/create.econda.data"));
const create_navigation_data_1 = __importDefault(require("./lib/create.navigation.data"));
const create_request_data_1 = __importDefault(require("./lib/create.request.data"));
const createDataLayerLibraryInnerHtml = ({ application, dataLayerData, dataLayerDataUrl, pageType, url, }) => {
    const dataLayer = (0, exports.createInitialDataLayer)({
        application,
        dataLayerData,
        pageType,
        url,
    });
    let dataLayerSnippet = `var dataLayer = window.dataLayer = ${JSON.stringify([dataLayer])};`;
    dataLayerSnippet += dataLayerDataUrl ? (0, build_xhr_request_1.buildXHRRequest)(dataLayerDataUrl) : '';
    return dataLayerSnippet;
};
exports.createDataLayerLibraryInnerHtml = createDataLayerLibraryInnerHtml;
/**
 * Prepares and returns dataLayer item
 */
const createInitialDataLayer = ({ application, dataLayerData, pageType, url, }) => {
    return {
        app: (0, create_app_data_1.default)(application, dataLayerData),
        countryCode: dataLayerData.countryCode,
        econda: (0, create_econda_data_1.default)(url.host, dataLayerData),
        languageCode: dataLayerData.language,
        navigation: (0, create_navigation_data_1.default)(pageType, url, dataLayerData.language),
        request: (0, create_request_data_1.default)(pageType, url.searchParams),
    };
};
exports.createInitialDataLayer = createInitialDataLayer;
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map